import { afterNextPaint } from '@helpers/after-next-paint';
import RfqModal from '@tkmp/rfq/components/RfqModal/RfqModal';
import { useInlineRfqForm } from '@tkmp/rfq/hooks/useInlineRfqForm/useInlineRfqForm';
import RFQButton from '@tkmp/rfq/shared/cta_box/RfqButton';
import React, { useCallback } from 'react';
import Styles from './Cta.scss';

export const Cta = () => {
	const formContext = useInlineRfqForm({
		initiator: 'Get a Personalized Quote CTA',
		freeTextLabel: 'Ask about pricing',
		headerText: 'Get a personalized quote',
		additionalInitiatedTrackingProps: {
			selection: 'View Packages',
		},
	});

	const handleCtaClick = useCallback(() => {
		afterNextPaint(() => {
			formContext.openModal();
		});
	}, [formContext.openModal]);

	return (
		<div>
			<RfqModal context={formContext} />
			<RFQButton
				wrapStyle={Styles.cta}
				type="message"
				color="secondary"
				size="md"
				label="Get a personalized quote"
				handleCTAClick={handleCtaClick}
				testId="pricing-details-personalized-quote"
			/>
		</div>
	);
};
